import React from "react";
import { Link } from "react-router-dom";
import {useSelector} from "react-redux";

function TopMenu({items, onClick}) {
    const user = useSelector(state => state.user);
    const [state, setActiveItem] = React.useState(null);
    return (
        <div className="menu--wrapper">
            <div className="menu">
                <div className="menu--content">
                    {items.map((item, index) => (
                    <div key={item} onClick={() => setActiveItem(index)} className={"menu--item" + (index === state ? " active" : "")}><Link to={item.link}><span>{item.title}</span></Link></div>)
                    )}
                    {(user?.userData?.role === 'teacher' || user?.userData?.role === 'admin') && 
                    <div className="menu--item"><Link to={'/admin-p'}><span>Админка</span></Link></div>}
                </div>
            </div>
        </div>
    )
}

export default TopMenu;